import Layout from './Layout';

export default Layout;
export { default as LayoutLanding } from './LayoutLanding';
export { default as LayoutPlain } from './LayoutPlain';
